<div class="card">
  <div class="card-header">
    INDICATEUR EGALIM
  </div>
  <div class="card-boby">
    <div class="gauge-container">
      <dx-bar-gauge
        id="gauge"
        [startValue]="startValue"
        [endValue]="endValue"
        [palette]="['var(--egalim-produit-durable-color)', 'var(--egalim-produit-bio-color)', 'var(--egalim-produit-poisson-viande-color)']"
        [values]="values"
      >
        <dxo-size
          height="100%"
          width="100%">
        </dxo-size>
        <dxo-label [visible]="true" [customizeText]="titleText"></dxo-label>
        <dxo-tooltip
          [enabled]="true"
          [customizeTooltip]="tooltipText"
        ></dxo-tooltip>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-title [text]="gaugeConforme ? 'Conforme à la loi Egalim' : 'Non conforme à la loi Egalim'">
          <dxo-font [size]="28" [color]="gaugeConforme ? 'var(--success-color)' : 'var(--error-color)'"></dxo-font>
          <dxo-subtitle [text]="gaugeSubtitle">
            <dxo-font [size]="14" [color]="'black'"></dxo-font>
          </dxo-subtitle>
        </dxo-title>
        <dxo-legend
          [visible]="true"
          verticalAlignment="bottom"
          horizontalAlignment="center"
          [customizeText]="legendText"
        >
        </dxo-legend>
        <span>Période du xx au xx</span>
      </dx-bar-gauge>
    </div>
    <div id="footer-seuil-container">
      <div *ngFor="let inputSeuil of inputSeuils" class="footer-seuil">
        <label class="padding-label-egalim">{{ inputSeuil.label }}</label>
        <input type="number" [style.max-width.px]="50" [(ngModel)]="inputSeuil.seuil" (change)="emitChangeSeuil()"/>
      </div>
    </div>
  </div>

</div>

